import { getStrWithCommas } from "../../utils/string";
import { replaceTierLimitsText, formatPrice } from "./pricing-utils";

const CLASSNAME_PREFIX = ".localized_pricing_";
const CLASSNAME_TO_REPLACE_FUNC = {
  [`${CLASSNAME_PREFIX}heading > .heading`]: replaceTierLimitsText,
  [`${CLASSNAME_PREFIX}currency_code`]: ({ currencyCode }) => currencyCode,
  [`${CLASSNAME_PREFIX}price`]: ({ price, currencyCode }) =>
    getStrWithCommas(formatPrice(price, currencyCode)),
  [`${CLASSNAME_PREFIX}primary_text`]: replaceTierLimitsText,
  [`${CLASSNAME_PREFIX}secondary_text`]: replaceTierLimitsText,
};

const doReplacements = (
  domRoot,
  currencyCode,
  { unitLimitLower, unitLimitUpper, price }
) =>
  Object.keys(CLASSNAME_TO_REPLACE_FUNC).forEach((sel) => {
    const replacementNode = domRoot.querySelector(sel);
    replacementNode.innerText = CLASSNAME_TO_REPLACE_FUNC[sel](
      {
        currencyCode,
        unitLimitLower: Math.max(unitLimitLower, 0),
        unitLimitUpper,
        price,
      },
      replacementNode.innerText
    );
  });

const onPricing = async (pricing, tierStart, domRoot) => {
  const { currencyCode, pricingTiers } = await pricing;
  if (pricingTiers[parseInt(tierStart)]) {
    doReplacements(domRoot, currencyCode, pricingTiers[parseInt(tierStart)]);
    domRoot.classList.remove("loading");
  }
};

export default class PriceBlockLocalized {
  constructor(domRoot, { pricing, tierStart }) {
    onPricing(pricing, tierStart, domRoot);
  }
}
